//Modules
import React from "react"
//Styles
import styled from "styled-components"
import { colors } from "../../Utilities"

const ColorTopBar = () => <StyledTopBar />

const StyledTopBar = styled.div`
  height: 0.5rem;
  width: 100vw;
  background: ${colors.primary};
`

export default ColorTopBar
